import { Link } from "react-router-dom";

export default function AuthCard({ eyebrow, title, desc, children }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6 py-12">
      <div className="w-full max-w-md fade-up rounded-2xl border border-slate-200 bg-white p-7 sm:p-8">
        <Link to="/"><img src="/logo-full.png" alt="Contestafood" className="mb-8 h-10 w-auto" /></Link>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-600">{eyebrow}</p>
        <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight text-slate-900" data-testid="auth-card-title">{title}</h1>
        {desc && <p className="mt-2 text-sm text-slate-500">{desc}</p>}
        <div className="mt-6">{children}</div>
      </div>
    </div>
  );
}
